/**
 * Cookehouse 2026: Sleepwear collection filters
 */

(function () {
  const toolbarSelector = '[data-ch26-filter-toolbar], .ch26-filter-toolbar';
  const groupSelector = '.ch26-filter-group';
  const summarySelector = '.ch26-filter-group__summary';

  function closeOtherGroups(currentGroup) {
    const toolbar = currentGroup.closest(toolbarSelector);
    const scope = toolbar || document;

    scope.querySelectorAll(groupSelector).forEach((group) => {
      if (group !== currentGroup) {
        group.removeAttribute('open');
      }
    });
  }

  function closeAllGroups(scope) {
    (scope || document).querySelectorAll(groupSelector).forEach((group) => {
      group.removeAttribute('open');
    });
  }

function keepPanelInViewport(group) {
  if (!group || !group.hasAttribute('open')) {
    return;
  }

  const panel = group.querySelector('.ch26-filter-group__panel');

  if (!panel) {
    return;
  }

  const viewportPadding = 16;

  panel.style.setProperty('--ch26-panel-shift-x', '0px');

  const rect = panel.getBoundingClientRect();

  let shiftX = 0;

  if (rect.right > window.innerWidth - viewportPadding) {
    shiftX = (window.innerWidth - viewportPadding) - rect.right;
  }

  if (rect.left + shiftX < viewportPadding) {
    shiftX += viewportPadding - (rect.left + shiftX);
  }

  panel.style.setProperty('--ch26-panel-shift-x', `${Math.round(shiftX)}px`);
}

  function initToolbar(toolbar) {
    if (toolbar.dataset.ch26FiltersInitialised === 'true') {
      return;
    }

    toolbar.dataset.ch26FiltersInitialised = 'true';

    toolbar.querySelectorAll(groupSelector).forEach((group) => {
      const summary = group.querySelector(summarySelector);

      if (summary) {
        summary.addEventListener('click', () => {
          const willOpen = !group.hasAttribute('open');

          if (willOpen) {
            closeOtherGroups(group);
          }

          window.requestAnimationFrame(() => {
            if (group.hasAttribute('open')) {
              closeOtherGroups(group);
              keepPanelInViewport(group);
            }
          });
        });
      }

      group.addEventListener('toggle', () => {
        if (group.hasAttribute('open')) {
          closeOtherGroups(group);
          window.requestAnimationFrame(() => keepPanelInViewport(group));
        }
      });
    });

    toolbar.addEventListener('change', (event) => {
      const input = event.target;

      if (!input.matches('input[type="checkbox"], input[type="radio"], select')) {
        return;
      }

      const form = input.closest('form');

      if (form) {
        form.submit();
      }
    });
  }

  function init() {
    document.querySelectorAll(toolbarSelector).forEach(initToolbar);
  }

  document.addEventListener('click', (event) => {
    const clickedToolbar = event.target.closest(toolbarSelector);

    document.querySelectorAll(toolbarSelector).forEach((toolbar) => {
      if (toolbar !== clickedToolbar) {
        closeAllGroups(toolbar);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllGroups(document);
    }
  });

  init();

  window.addEventListener('resize', () => {
    document.querySelectorAll(`${groupSelector}[open]`).forEach(keepPanelInViewport);
  }, { passive: true });
})();
